/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_None_SelectedInputs */

const en_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Event Groups or Presets selected.`)
};

const fr_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun groupe d’événements ou préréglage sélectionné.`)
};

const de_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind keine Ereignisgruppen oder Voreinstellungen ausgewählt.`)
};

const it_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun gruppo di eventi o preset selezionato.`)
};

const ru_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группы событий и предустановки не выбраны.`)
};

const es_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay grupos de eventos ni ajustes preestablecidos seleccionados.`)
};

const zh_cn2_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何事件组或预设。`)
};

const ja_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループまたはプリセットが選択されていません。`)
};

const hi_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई इवेंट ग्रुप या प्रीसेट चयनित नहीं हैं।`)
};

const pt_pt2_batch_subtitle_export_none_selected = /** @type {(inputs: Batch_Subtitle_Export_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum grupo de eventos ou predefinição selecionado.`)
};

/**
* | output |
* | --- |
* | "No Event Groups or Presets selected." |
*
* @param {Batch_Subtitle_Export_None_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_none_selected = /** @type {((inputs?: Batch_Subtitle_Export_None_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_None_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_none_selected(inputs)
	if (locale === "de") return de_batch_subtitle_export_none_selected(inputs)
	if (locale === "it") return it_batch_subtitle_export_none_selected(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_none_selected(inputs)
	if (locale === "es") return es_batch_subtitle_export_none_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_none_selected(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_none_selected(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_none_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_none_selected(inputs)
	return en_batch_subtitle_export_none_selected(inputs)
});